import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { catchError, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { Router } from '@angular/router';
import {  NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

import { Observable } from 'rxjs';
import { AepsService } from '../aeps/aeps.service';

import { MyErrorStateMatcher } from '../bharatbillpay/electricity/electricity.component';
import { KycService } from '../services/kyc.service';

import { HttpErrorResponse } from '@angular/common/http';
import { AepsdeviceConfigModelComponent } from '../aeps/aepsdevice-config-model/aepsdevice-config-model.component';
import { ToastrService } from 'ngx-toastr';
import { TemplateRef, ViewChild } from '@angular/core';
import { KYCSuccessDialogComponentComponent } from '../kycsuccess-dialog-component/kycsuccess-dialog-component.component';
import { AuthService } from '../auth/auth.service';
@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss']
})
export class KycComponent implements OnInit {
  @ViewChild('kycSuccessModal') kycSuccessModal: TemplateRef<any>;
  kycForm: FormGroup;
  submitted: boolean;
  dthsubmitted = false;
  isloading: boolean;
  showOTPDiv: boolean = false;
  showCaptureBtn: boolean = false;

  dthOperatorsList: any;
  commonlocationList: any;
  userCurrenPosition: any;
  opsmsg: string;
  msgdivshow = false;
  deviceInfo: any;
  lat;
  lng;
  zoom;
  rechargeInfo: any;
  deviceInfoRes$: Observable<any>;
  captureRes$: Observable<any>;
  // devices = [
  //   { name: 'Mantra MFS100', value: 'mantra' },
  //   { name: 'Morpho MSO 1300', value: 'morpho' },
  //   { name: 'Startek FM220U', value: 'startek' },
  //   // { name: 'Aratek A600', value: 'aratek' }
  // ];
  devices:any;
  matcher = new MyErrorStateMatcher();
  constructor(private formBuilder: FormBuilder,
    private kycservice: KycService,
    private toastr: ToastrService,
    private Aeps: AepsService,
    config: NgbModalConfig,
    private auth: AuthService,
    
    private router: Router,    
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;

    this.kycForm = this.formBuilder.group({
      aadharNum: ['', Validators.required],
      fullName: ['', Validators.required],
      mobileNum: ['', Validators.required],
      device: ['mantra', Validators.required],
      comment: ['ok', Validators.required],
      otp: [''],
    });


    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 16;

      });
    }
    this.Aeps.deviceInfoRes.subscribe(x => this.deviceInfo = x);

    this.deviceInfoRes$ = this.Aeps.deviceInfoRes;
    this.deviceInfoRes$.pipe(untilDestroyed(this), catchError(this.handleError)).subscribe((data: any) => {
      this.spinner.hide();
      if (this.submitted == true) {
        this.Aeps.deviceCapture(this.kycForm);
      }
    });
    this.captureRes$ = this.Aeps.captureRes;
    this.captureRes$.pipe(untilDestroyed(this)).subscribe((deviceInfo) => {
      console.log('deviceInfo :::', deviceInfo);
      if (deviceInfo && deviceInfo.PidData && deviceInfo.PidData.Resp['@attributes'].errCode == '-1509'
        || deviceInfo && deviceInfo.PidData && deviceInfo.PidData.Resp['@attributes'].errCode == '715') {
        window.open('chrome://flags/#allow-insecure-localhost');
        this.spinner.hide();
        const dialogRef = this.dialog.open(AepsdeviceConfigModelComponent, {
          height: '80%',
          data: { code: deviceInfo.PidData.Resp['@attributes'].errCode, msg: deviceInfo.PidData.Resp['@attributes'].errInfo,deviceType:this.kycForm.value.device }
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
          this.router.navigate['/dashboard'];

        });
      } else if (deviceInfo && deviceInfo.PidData && deviceInfo.PidData.Resp['@attributes'].errCode == '700') {
        this.spinner.hide();
        this.toastr.error(deviceInfo.PidData.Resp['@attributes'].errInfo, '');
      }
      if (deviceInfo && deviceInfo.PidData && deviceInfo.PidData.Skey && deviceInfo.PidData.Skey['@attributes']) {
        this.spinner.show();
        const deviceParams = {
          ci: deviceInfo.PidData.Skey['@attributes'].ci,
          dc: deviceInfo.PidData.DeviceInfo['@attributes'].dc,
          dpID: deviceInfo.PidData.DeviceInfo['@attributes'].dpId,
          errCode: deviceInfo.PidData.Resp['@attributes'].errCode,
          errInfo: deviceInfo.PidData.Resp['@attributes'].errInfo,
          fCount: deviceInfo.PidData.Resp['@attributes'].fCount,
          fType: deviceInfo.PidData.Resp['@attributes'].fType,
          hmac: deviceInfo.PidData.Hmac['#text'],
          iCount: '0',
          mc: deviceInfo.PidData.DeviceInfo['@attributes'].mc,
          mi: deviceInfo.PidData.DeviceInfo['@attributes'].mi,
          nmPoints: deviceInfo.PidData.Resp['@attributes'].nmPoints,
          pCount: '0',
          pType: '0',
          pidDatatype: deviceInfo.PidData.Data['@attributes'].type,
          piddata: deviceInfo.PidData.Data['#text'],
          qScore: deviceInfo.PidData.Resp['@attributes'].qScore,
          rdsID: deviceInfo.PidData.DeviceInfo['@attributes'].rdsId,
          rdsVer: deviceInfo.PidData.DeviceInfo['@attributes'].rdsVer,
          sessionKey: deviceInfo.PidData.Skey['#text'],

        };
        const cardnumberORUIDObj = {
          adhaarNumber: this.kycForm.value.aadharNum,
          indicatorforUID: '0',
          nationalBankIdentificationNumber: ''
        };
        const finalObj = {
          captureResponse: deviceParams,
          cardnumberORUID: cardnumberORUIDObj,
          requestRemarks: this.kycForm.value.comment
        };

        this.kycservice.doKYC(finalObj,this.lat,this.lng).subscribe((res: any) => {
          console.log('kyc response::', res);
          this.spinner.show();
          if (res.status_code == 1) {
            this.spinner.hide();
            this.submitted = false;
            this.kycForm.reset();
            localStorage.clear();              
            const dialogRef = this.dialog.open(KYCSuccessDialogComponentComponent, {
              width: '250px',
              height: '250px',
              disableClose: true
            });
          } else {
            this.spinner.hide();
          }
        });        
      }

    });



  }

  handleError = (error: HttpErrorResponse): any => {
    console.log('error', error);
  }
  get d() { return this.kycForm.controls; }
  ngOnInit(): void {  
    this.getDevices();
    let isUserKYCDone = localStorage.getItem('tapekycstatus');        
    if (isUserKYCDone=='TRUE') {
      this.router.navigate(['/aeps']);
    }    
  }
  getDevices(){
   
    this.auth.getDevicesApi().subscribe((res: any) => {
      if (res.status_code == 1) {
          this.devices=res.object;
          // if

      } else {
        // this.toastr.error(res.error.message);

      }
    }, errData => {
      this.spinner.hide()
    })
  

}
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }



  sendOtp() {
    this.spinner.show();
    this.kycservice.sendOTPForKYC(this.kycForm.value.aadharNum, this.lat, this.lng)
      .subscribe((data: any) => {
        console.log(data.status);
        if (data.status_code == 1) {
          this.showOTPDiv = true;

        }
        this.spinner.hide();
      }, (err) => {
        this.spinner.hide();

      });
  }
  verifyOtp() {
    this.spinner.show();
    this.kycservice.verifyOTPKYC(this.kycForm.value.otp)
      .subscribe((data: any) => {
        console.log(data.status);
        if (data.status_code == 1) {
          this.showCaptureBtn = true;
          this.showOTPDiv = false;

        }
        this.spinner.hide();
      }, (err) => {
        this.spinner.hide();

      });
  }



  doKYC() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.kycForm.invalid) {
      return;
    }
    else {
      this.Aeps.deviceInfoAvdm(this.kycForm);

    }
  }

  ngOnDestroy() {
    // You can also do whatever you need here
  }

}
